import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
interface Props {
  title: string;
}

const PageTitle = ({ title }: Props) => {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>countX | {t(title)}</title>
    </Helmet>
  );
};

export default PageTitle;
